import 'slick-carousel';

import createBehavior from '../create-behavior';

const Modernizr = global.Modernizr;

export default () => {
  class QuartalSlider {
    constructor($el, context, settings) {
      let activeslide = $el.find('a.active');
      let activeslideindex = activeslide.index();


      let config = {
        slidesToShow: 1,
        focusOnSelect: true,
        responsive: [{
            breakpoint: 1025,
            settings: {
              centerMode: true,
              slidesToShow: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              centerMode: true,
              slidesToShow: 1
            }
          }
        ]
      };
      if (!$el.hasClass('quartal-slider__slider--promo')) {
        config = {
          ...config,
          slidesToShow: 3,
          centerPadding: '60px',
          centerMode: true,
          variableWidth: true
        }
      }
      if (activeslide.length > 0) {
        config = {
          ...config,
          initialSlide: activeslideindex
        }
      }
      $el.slick(config);
    }
  }

  createBehavior('.quartal-slider__slider', 'QuartalSlider', QuartalSlider);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/quartal-slider.js